import { render, staticRenderFns } from "./SuspendMediaModal.vue?vue&type=template&id=7f952911&scoped=true&"
import script from "./SuspendMediaModal.vue?vue&type=script&lang=js&"
export * from "./SuspendMediaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f952911",
  null
  
)

export default component.exports